import { render, staticRenderFns } from "./editAdd.vue?vue&type=template&id=55f48cd1&"
import script from "./editAdd.vue?vue&type=script&lang=ts&"
export * from "./editAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports